import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarehousePageWrapper, WarehousePageWrapperActions } from '../../ui-kit';
import { routePaths } from '../../routePaths';
import { WarehousePermission } from '../../generated/graphql';
import { IS_ROSSUM_ENABLED } from '../../constants';
import { DeliveryListsTable, PendingDeliveryListsTable } from './components';

interface DeliveryListsPageProps {
    activePageIndex: number;
}

const DeliveryListsPage = ({ activePageIndex }: DeliveryListsPageProps) => {
    const { t } = useTranslation();
    const addNewDeliveryListString = t('New delivery list');
    const uploadDeliveryListString = t('Upload');

    let actions: WarehousePageWrapperActions = [
        {
            route: routePaths.warehouseDeliveryLists,
            text: addNewDeliveryListString,
        },
    ];

    if (IS_ROSSUM_ENABLED) {
        actions = [
            {
                isRouteExplicit: true,
                route: routePaths.warehouseDeliveryListsUpload,
                text: uploadDeliveryListString,
                variant: 'outlined',
            },
            ...actions,
        ];
    }

    return (
        <WarehousePageWrapper
            permissions={{ warehouse: [WarehousePermission.CanAddDeliveryList] }}
            actions={actions}
        >
            {activePageIndex === 0 && <DeliveryListsTable />}
            {activePageIndex === 1 && <PendingDeliveryListsTable />}
        </WarehousePageWrapper>
    );
};

export default DeliveryListsPage;
